



























































































import { Http } from "fs-pb-vue2/services/api/http";
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { AppStore } from "fs-pb-vue2/store/modules/app";
import { clientTime } from "fs-pb-vue2/utilities";

@Component
export default class ClientInterviewDataForm extends Vue {
  @Watch("interviewModel.residentTax")
  residentTaxChanged(): void {
    this.interviewModel.countryResident = "";
    this.interviewModel.innResident = "";
  }

  @Prop() sessionId!: string
  /**Стор настроек */
  get appStore(): AppStore {
    return getModule(AppStore, this.$store);
  }
  errorText: string = "";
  isError: boolean = false;

  rules: Array<any> = [
    (l: any) => !!l || "Необходимо заполнить поле"
  ];

  interviewModel: any = {
    countryBirth: "",
    addressMatches: false,
    residentTax: null,
    countryResident: "",
    innResident: "",
    informationReliable: false,
    agreeProcessingData: false,
    notAmPublic: false,
    withoutBenefitsThirdPersons: false,
    beneficiary: null
  }

  validateForm(): void {
    // Проверяем форму на валидность
    (this.$refs.form as any).validate();
  }

  resetFormValidation(): void {
    // Сбрасываем реззультаты валидации
    (this.$refs.form as any).resetValidation();
  }

  valid: boolean = true;

  async sendQuestionnaire(): Promise<void> {
    this.appStore.setLoading(true);

    this.valid = (this.$refs.form as Vue & { validate: () => boolean }).validate();

    if (!this.valid) {
      this.appStore.setLoading(false);
      return;
    }

    if (!this.interviewModel.countryBirth || !this.interviewModel.addressMatches || !this.interviewModel.informationReliable
      || !this.interviewModel.agreeProcessingData) {
      this.isError = true;
      this.errorText = "Все поля в Анкете обязательны к заполнению";
      this.appStore.setLoading(false);
      return;
    }
    if (!this.interviewModel.notAmPublic || !this.interviewModel.withoutBenefitsThirdPersons || !this.interviewModel.beneficiary) {
      this.isError = true;
      this.errorText = "К сожалению, мы не можем идентифицировать Вас удаленно. Для оказания услуги просим Вас лично обратиться в отделение банка";
      this.appStore.setLoading(false);
      return;
    }

    let message = "";
    const code: any = this.$route.query["code"];
    try {
      const dataToSend = {
        sessionId: code,
        interviewResult: JSON.stringify({dateInterview :{
          countryBirth: this.interviewModel.countryBirth,
          addressMatches: this.interviewModel.addressMatches,
          residentTaxNo: !this.interviewModel.residentTax,
          residentTaxYes: !!this.interviewModel.residentTax,
          countryResident: this.interviewModel.countryResident,
          innResident: this.interviewModel.innResident,
          informationReliable: this.interviewModel.informationReliable,
          agreeProcessingData: this.interviewModel.agreeProcessingData,
          notAmPublic: this.interviewModel.notAmPublic,
          withoutBenefitsThirdPersons: this.interviewModel.withoutBenefitsThirdPersons,
          beneficiaryYes: !!this.interviewModel.beneficiary,
          beneficiaryNo: !this.interviewModel.beneficiary
        }}), clientTime: clientTime()
      };

      const resp = await Http.post(`EbsEsia/SendResult`, dataToSend);
      if (resp.result == "error") {
        message = resp.message;
      } else {
        message = resp.data.messageText;
      }
    } catch (e) {
      message = e;
    }

    this.appStore.setLoading(false);

    this.$emit("accepted", message)
  }
}
